export default "__VITE_ASSET__Ct_Hup8b__"